import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DISPUTE_TO_COMPLETED_ORDER_STATUS_REASONS } from 'constants/order.constants';
import {
  AdditionalOrderColumn,
  CallbackUrlStatus,
  FilterDefinitionType,
  OrdersTab,
  OrderCompletedBy,
  OrderStatusReason,
} from 'enums';
import { useOrderQueryFilters } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { ManageOrdersList } from '../ManageOrderList';

export const CompletedOrders: React.FC = () => {
  const { t: tFilters } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.filters',
  });

  useOrderQueryFilters();

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [
      {
        label: tFilters('automation_status'),
        name: 'completedBy',
        type: FilterDefinitionType.Enum,
        enum: OrderCompletedBy,
        getDisplayName: orderUtils.getCompletedByLabel,
      },
      {
        label: tFilters('callback_url_status'),
        name: 'callbackUrlStatus',
        type: FilterDefinitionType.Enum,
        enum: CallbackUrlStatus,
        getDisplayName: orderUtils.getCallbackUrlStatusLabel,
      },
      {
        label: tFilters('status_reason'),
        name: 'statusReason',
        type: FilterDefinitionType.Enum,
        enum: DISPUTE_TO_COMPLETED_ORDER_STATUS_REASONS,
        getDisplayName: (value: OrderStatusReason) =>
          orderUtils.getStatusReasonLabel(value),
      },
    ],
    [tFilters],
  );

  return (
    <ManageOrdersList
      tab={OrdersTab.Completed}
      additionalColumns={[
        AdditionalOrderColumn.CustomerPayment,
        AdditionalOrderColumn.TraderCard,
        AdditionalOrderColumn.AutomationStatus,
        AdditionalOrderColumn.OrderProcessedBy,
        AdditionalOrderColumn.Validation,
      ]}
      additionalFilters={additionalFilters}
    />
  );
};
